import {useEffect, useRef, useState} from 'react';
import styles from './index.module.scss';
import {isNumber} from 'lodash-es';
import loadingImg from '@/assets/img/loading.png';
import {EDITOR_MODE} from '@/Constant';

interface StatisticCountProps{
    docWordNum?: {
        totalWordCount: number;
        selectedWordCount?: number;
    };
    documentMode?: EDITOR_MODE;
    demoMode?: boolean;
}

export default function StatisticCount(props: StatisticCountProps) {
    const {docWordNum} = props;
    const [loading, setLoading] = useState(true);
    const target = useRef<any>();

    useEffect(() => {
        if (docWordNum) {
            setLoading(false);
        }
    }, [docWordNum]);

    function getWordCont(totalWordCount?: number, selectedWordCount?: any) {
        if (isNumber(selectedWordCount)) {
            return `${selectedWordCount}/${totalWordCount} 个字`;
        }
        return `${totalWordCount} 个字`;
    }

    return <>
        <div
            className={styles.wordRoot}
        >
            {
                loading
                    ? <div className={styles.loadWord}>
                        <img src={loadingImg} className={styles.loading} alt="" />
                        <span>字数统计中...</span>
                    </div>
                    :
                    <div className={styles.wordSty} ref={target}>
                        {getWordCont(docWordNum?.totalWordCount, docWordNum?.selectedWordCount)}
                    </div>
            }
            <div className={styles.divider}></div>
        </div>
    </>;
}
